import React from 'react';
import EmptyPage from './EmptyPage';
import NoSurveyDataImage from '../assets/images/emptyPages/NoSurveyData.svg';
import { getTranslation } from '../locales';

interface InvalidUrlPageProps {
  locale?: string;
}

const InvalidUrlPage: React.FC<InvalidUrlPageProps> = ({ locale = "en" }) => {
  const t = getTranslation(locale);
  
  return (
    <EmptyPage
      message={t.invalidSurveyUrl}
      subMessage={t.invalidUrlMessage}
      image={NoSurveyDataImage}
    />
  );
};

export default InvalidUrlPage;
